'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var PropTypes = require('prop-types');
var nthGrid = require('@narvar/nth-grid');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var nthHookSettings = require('@narvar/nth-hook-settings');
var polished = require('polished');
var layoutTree = require('./layoutTree.js');
var LayoutComponent = require('./LayoutComponent.js');
var gridComponents = require('./gridComponents.js');
var useWindowSize = require('./hooks/useWindowSize.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

const {
  breakpointMinWidths,
  WIDTH_MD
} = nthGrid.constants;
const KitDynamicLayout = _ref => {
  let {
    deviceLayoutName = 'trackPageLayout',
    breakpoints,
    feature,
    transformLayout,
    userAgentDevice,
    fixedSize,
    view
  } = _ref;
  const {
    [deviceLayoutName]: deviceLayoutUntransformed
  } = nthHookSettings.useSettings();

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const deviceLayout = typeof transformLayout === 'function' ? transformLayout(deviceLayoutUntransformed) : deviceLayoutUntransformed;
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  React.useEffect(() => {
    if (!deviceLayout || !deviceLayout[layoutTree.Devices.MOBILE]) return;
    logEvent({
      eventType: nthHookContextAnalytics.NarvarEventTypes.PAGE_LOAD,
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_KIT_DYNAMIC_LAYOUT,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_KIT_DYNAMIC_LAYOUT,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_KIT_DYNAMIC_LAYOUT,
      trackLayout: deviceLayoutName
    });
  },
  // TODO: Make this dependency array exhaustive
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [deviceLayoutName]);
  if (!deviceLayout || !deviceLayout[layoutTree.Devices.MOBILE]) return null;
  return /*#__PURE__*/React__default["default"].createElement(LayoutComponent["default"], {
    userAgentDevice: userAgentDevice,
    deviceLayout: deviceLayout,
    breakpoints: breakpoints,
    feature: feature,
    fixedSize: fixedSize,
    view: view
  });
};
KitDynamicLayout.defaultProps = {
  breakpoints: {
    [layoutTree.Devices.DESKTOP]: polished.stripUnit(breakpointMinWidths[WIDTH_MD])
  },
  deviceLayoutName: 'trackPageLayout',
  transformLayout: null
};
KitDynamicLayout.propTypes = {
  breakpoints: PropTypes__default["default"].shape({
    [layoutTree.Devices.DESKTOP]: PropTypes__default["default"].number.isRequired
  }),
  feature: PropTypes__default["default"].func.isRequired,
  deviceLayoutName: PropTypes__default["default"].string,
  transformLayout: PropTypes__default["default"].func,
  userAgentDevice: PropTypes__default["default"].oneOf([layoutTree.Devices.MOBILE, layoutTree.Devices.DESKTOP])
};
const KitDynamicLayoutWithSettings = _ref2 => {
  let {
    deviceLayoutName = 'trackPageLayout',
    ...props
  } = _ref2;
  return /*#__PURE__*/React__default["default"].createElement(nthHookSettings.SettingsProvider, {
    settingsRequested: deviceLayoutName
  }, /*#__PURE__*/React__default["default"].createElement(KitDynamicLayout, _extends__default["default"]({
    deviceLayoutName: deviceLayoutName
  }, props)));
};
KitDynamicLayoutWithSettings.propTypes = KitDynamicLayout.propTypes;

exports.LayoutTree = layoutTree;
exports.Container = gridComponents.containerComponent;
exports.DT_DEFAULT_MAX_WIDTH = gridComponents.DT_DEFAULT_MAX_WIDTH;
exports.useWindowSize = useWindowSize["default"];
exports["default"] = KitDynamicLayoutWithSettings;
